import { Component, Input, OnInit } from '@angular/core';
import { PopulationQuery } from '@fgb/core';
import { Populations } from '../../utilities/populations';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit {
  @Input() title: string = '';
  @Input() isHomePage: boolean = false;
  @Input() memberId: string = '';
  @Input() isImageBanner: boolean = false;
  @Input() imageBannerUrl: string = '';
  populations = Populations;
  isCorporate: boolean;
  isKid: boolean;
  constructor(private populationQuery: PopulationQuery) {}

  ngOnInit() {
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
    this.isKid = this.populationQuery.userInPopulation([this.populations.JuniorBluebirds]);
  }
}
